import BaseApi from 'api/core/baseApi';
import { ENDPOINTS } from 'api/config/endpoints';

class ProductNameApi extends BaseApi {
  constructor() {
    super(ENDPOINTS.PRODUCT_NAME);
  }
}

export default new ProductNameApi();
